<header [ngClass]="stagingIndictator">
  <div class="top-header-content"
       [class.exclusive-search]="exclusiveSearch">
    <button mat-icon-button
            (click)="toggleMobileMenu()"
            class="nav-menu">
      <mat-icon>menu</mat-icon>
    </button>
    <a id="logo"
       [href]="getFiveUrl('dashboard')"
       (click)="handleFiveNavigation('dashboard', $event)">
      <img [src]="brandmark"
           alt="EZLynx" />
    </a>
    <div class="leading-content">
      <div class="search-container">
        <form class="applicant-search"
              ngNoForm
              [action]="searchRoute">
          <input placeholder="Search"
                 [(ngModel)]="globalSearchTerm"
                 [matAutocomplete]="foundApplicants"
                 matInput
                 #searchTerm="ngModel"
                 class="applicant-search-input"
                 id="quickSearchInput"
                 name="searchPhrase">
          @if (searching) {
            <mat-spinner class="search-loader"
                         diameter="20" />
          }
          <a mat-icon-button
             [href]="searchRoute + (globalSearchTerm ? '?searchPhrase=' + encodeSearchTerm(globalSearchTerm) : '')"
             id="applicant-search-link">
            <mat-icon>search</mat-icon>
          </a>
        </form>
        <mat-autocomplete #foundApplicants="matAutocomplete"
                          class="applicant-search-panel dynamic-height-panel full-width-options">
          <div class="search-results"
               id="applicant-search-results">
            @for (result of superSearchResults; track result) {
              <mat-option>
                <a [href]="result.url"
                   (click)="handleNavigation(result.url, $event)">
                  <mat-icon [svgIcon]="result.useSVG ? result.icon : ''">
                    @if (!result.useSVG) {
                      {{result.icon}}
                    }
                  </mat-icon>
                  {{result.label}}
                </a>
              </mat-option>
              <mat-divider />
            }
            @for (applicant of applicants; track applicant) {
              <mat-option class="applicant-result">
                <a (click)="handleFiveNavigation('account/' + applicant.id + '/overview', $event)"
                   [href]="getFiveUrl('account/' + applicant.id + '/overview')">
                  <div class="name-type-container">
                    <b>{{applicant.name}}</b>
                    <span class="account-type">{{applicant.isCommercial ? 'Commercial' : 'Personal'}}</span>
                  </div>
                  <span>{{applicant.address.firstLine}}</span>
                  <span>{{applicant.address.cityStateZip}}</span>
                  <span>Assigned Producer: {{applicant.assignedUser}}</span>
                  <span>CSR: {{applicant.csrUser}}</span>
                  <span>Agency: {{applicant.agency | NoValue}}</span>
                  @for (highlight of applicant.highlights; track highlight) {
                    <span>
                      {{highlight.key}} {{highlight.value}}
                    </span>
                  }
                  <ez-chip [color]="getChipColor(applicant.status)">
                    {{applicant.status}}
                  </ez-chip>
                </a>
              </mat-option>
              <mat-divider />
            }
            @if (noResults && globalSearchTerm) {
              <mat-option class="no-results">
                No Results Found
              </mat-option>
            }
          </div>
          @if (numFound) {
            <div class="search-footer mat-typography">
              <span>Showing {{applicants.length}} of {{numFound}}</span>
              <a [href]="searchRoute + '?searchPhrase=' + encodeSearchTerm(globalSearchTerm)">Show All Results</a>
            </div>
          }
        </mat-autocomplete>
      </div>
      @if (hasEVASidebarAccess()) {
        <button type="button"
                color="accent"
                mat-flat-button
                class="eva-ai"
                (click)="toggleEvaSidebar()">
          EVA AI
          <mat-icon svgIcon="eva-animated" />
        </button>
      }
    </div>
    @if (user) {
      <div class="avatar-with-eva">
        @if (hasEVAPaneAccess()) {
          <button id="eva-header"
                  type="button"
                  class="eva-animated-button"
                  mat-stroked-button
                  (click)="showEVAPane($event)">
            <mat-icon svgIcon="eva-animated" />
            AI
          </button>
        }

        <ez-avatar [firstName]="user.firstName"
                   [lastName]="user.lastName"
                   [matMenuTriggerFor]="userMenu" />
        <mat-menu #userMenu>
          <small mat-menu-item
                 class="username"
                 disabled>{{user.userName}}</small>
          <a mat-menu-item
             [href]="getFiveUrl('user-settings')"
             (click)="handleFiveNavigation('user-settings', $event)"
             id="UserSettingsLink">
            User settings</a>
          <a mat-menu-item
             [href]="logoutUrl"
             id="LogoutLink">Logout</a>
        </mat-menu>
      </div>
    } @else {
      <div class="fill-space"></div>
    }

    @if (hasWorkspaceAccess) {
      <div class="workspace-actions">
        <button type="button"
                mat-icon-button
                (click)="showAddNote($event)"
                title="Add Note"
                id="add-note-header">
          <mat-icon>note_add</mat-icon>
        </button>
        <button type="button"
                mat-icon-button
                (click)="showTaskList($event)"
                title="Task List"
                id="task-list-header">
          <mat-icon [matBadge]="taskCount"
                    [matBadgeColor]="taskCountColor"
                    aria-hidden="false">list</mat-icon>
        </button>
        <button id="header-notifications"
                type="button"
                mat-icon-button
                (click)="showNotifications($event)"
                title="Notifications">
          <mat-icon [matBadge]="notificationCount"
                    matBadgeColor="accent"
                    aria-hidden="false">notifications</mat-icon>
        </button>
        @if (hasWorkflowAccess) {
          <button type="button"
                  mat-icon-button
                  (click)="showWorkflows($event)"
                  title="Workflows">
            <mat-icon>account_tree</mat-icon>
          </button>
        }
      </div>
    }

    @if (!hasEVAPaneCPAAccess()) {
      <button type="button"
              class="help-icon"
              mat-icon-button
              (click)="showHelp()"
              title="Chat Support (ctrl+/)">
        <mat-icon [matBadge]="freshChatUnreadCount()"
                  matBadgeColor="accent">help</mat-icon>
      </button>
    } @else {
      <button type="button"
              class="help-icon"
              mat-icon-button
              [matMenuTriggerFor]="helpMenu"
              title="Help">
        <mat-icon>help</mat-icon>
      </button>
      <mat-menu #helpMenu="matMenu">
        @if (!hasEVASidebarAccess()) {
          <button id="eva-header-question"
                  mat-menu-item
                  class="accent-menu-item"
                  (click)="showEVAPaneCPA()"><mat-icon svgIcon="eva" />Ask EVA</button>
        }

        <button mat-menu-item
                (click)="showHelp()"
                title="Chat Support (ctrl+/)">Chat support</button>

      </mat-menu>
    }

    <button class="mobile-search"
            type="button"
            mat-icon-button
            (click)="toggleMobileSearch()"
            title="Global Search">
      @if (!exclusiveSearch) {
        <mat-icon>search</mat-icon>
      }
      @if (exclusiveSearch) {
        <mat-icon>clear</mat-icon>
      }
    </button>
  </div>
</header>

@if (!isFive) {
  @if (workspaceVisible()) {
    <ez-workspace @workspaceSidebar />
  }
  @if (showExtended()) {
    <div class="extended-sidebar"
         @workspaceSidebar>
      <ng-template #extendedWorkspaceTemplate />
    </div>
  }
}